import { _postV1, _getV1 } from './config/index'

export async function sendSmsOtpForLogin(inputKind:'email' | 'phone', phoneemail: string, countryCode: string): Promise<any> {
  try {
    const response = await _postV1(`/auth/sendOtp`,{ 'inputKind':inputKind,'emailPhone':phoneemail,'countryCode':countryCode })
    return response
  } catch (error: any) {
    console.log('Error on POST sendSmsOtpForLogin:', error)
    return {
      error: true,
      message: error,
    }
  }
}

export async function verifySmsOtp(toNumber: string, enteredOtp: string, fcmDeviceToken: string): Promise<any> {
  try {
    const response = await _postV1('/auth/confirmOtp', {
      emailPhone: toNumber,
      enteredOtp: enteredOtp,
      fcmDeviceToken: fcmDeviceToken
    })
    return response
  } catch (error: any) {
    console.log('Error on POST verifySmsOtp:', error)
    return {
      error: true,
      message: error,
    }
  }
}

export async function refreshToken (f:(_:string) => void){
  const res = await _postV1('/refresh-token',{})
  console.log('refreshToken',res)
  f((res).data.token)
}
